/**
 * import topicsDir from "../__topicsDir";
*/

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2024-03-27T11:00",
		title: `
		<h4>新潟県医師会在宅医療推進センター入退院連携検討委員会</h4>
		<p class="paragraph-indent">
		●「入退院連携ガイドを活用した入退院支援の手引き」を作成いたしました。<br>
		<a href="/contents/download/">資料ダウンロードページ【関係者専用：パスワード要】をご参照ください。</a><br>
		パスワードは、各郡市医師会在宅医療推進センターまたはお問合せフォームよりお問い合わせください。
		</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
